import api from "../api";

export const UseCreateDao = (data) =>
    api.post("/dao", data).then((res) => res.data);
